import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);

const SUPPORTED = ['lt', 'en', 'de', 'ru'];
const DEFAULT_LANG = 'lt';

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem('mg_lang') : null;
    return SUPPORTED.includes(stored) ? stored : DEFAULT_LANG;
  });

  useEffect(() => {
    localStorage.setItem('mg_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split('.');
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, supported: SUPPORTED }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
